// extracted by mini-css-extract-plugin
export default {"appContainer":"layout_appContainer__CM-A0"};